export default "__VITE_ASSET__BAHaa2NE__"